var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Toast'),_c(_vm.layout,{tag:"component"}),_c('vue-progress-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }